import { education } from "../../data/resume";

function Education() {
    return (
        <section id="education" className="section section-alt">
            <div className="container">
                <div className="section-header">
                    <p className="section-eyebrow">How I got here</p>
                    <h2 className="section-title">Education</h2>
                </div>
                <div className="timeline">
                    {education.map((item) => (
                        <div className="timeline-item" key={item.degree}>
                            <div className="timeline-dot" />
                            <div className="timeline-content">
                                <span className="timeline-time">{item.time}</span>
                                <h3>{item.degree}</h3>
                                <p>{item.school} — {item.location}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Education;
